export const CARD_WIDTH = 320

export const addRandomNumber = (num: number, maxNumber: number) => {
  const half = (maxNumber - CARD_WIDTH) / 2
  const sign = Math.random() < 0.5 ? -1 : 1
  const halfRandom = Math.floor(Math.random() * half) * sign
  return num + halfRandom
}
